import { http } from "../api/http";
import Utils from "../utils";

// GraceBot (execution summary) — a one-shot, plain-language summary of a single runbook
// execution's history. No conversation, no user-supplied question: the backend
// (RunbookAIBuilder's execution-summary bot) pulls and aggregates
// RunbookExecutionHistory/RunbookExecutionHistoryLine itself and returns a fixed narrative.
//
// GET /runbook/executionhistory/{executionId}/ai-summary?clientId=...
// clientId is optional — the API stamps it from the caller's own claim for regular users;
// only a super user's explicit clientId is honored.
// Response: { executionId, runbookId, runbookName, summary, generatedAtUtc }
export const executionAssistService = {
  getSummary,
};

function getSummary(executionId, clientId) {
  const query = Utils.objectToQueryString({ clientId });
  const url = `/runbook/executionhistory/${encodeURIComponent(executionId)}/ai-summary${
    query ? `?${query}` : ""
  }`;
  return http.get(url).then((response) => response.data);
}
